import React from "react";
import Box from "@mui/material/Box/Box";
import { CircularProgress } from "@mui/material";

interface Props {
  headerOffset?: number;
}

function GenieSpinner({ headerOffset = 0 }: Props) {
  return (
    <Box
      width={"100vw"}
      height={`calc(100vh - ${headerOffset}px)`}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress />
    </Box>
  );
}

export default GenieSpinner;
